import { configureStore } from '@reduxjs/toolkit';

// Slices
import themeSlice from './slices/theme';
import documentSlice from './slices/document';
import signsSlice from './slices/signs';
import sidebarSectionsSlice from './slices/sidebarSections';
import userInfoSlice from './slices/userInfo';
import fielSlice from './slices/fiel';
import gptSlice from './slices/gptSummary';
import listPrevSignersSlice from './slices/listPrevSigners';
import invitedSlice from './slices/invited';
import commentSlice from './slices/commentSlice';

export const store = configureStore({
  reducer: {
    theme: themeSlice,
    document: documentSlice,
    signs: signsSlice,
    sidebarSections: sidebarSectionsSlice,
    userInfo: userInfoSlice,
    fiel: fielSlice,
    gpt: gptSlice,
    listPrevSigners: listPrevSignersSlice,
    invited: invitedSlice,
    comments: commentSlice
  }
});
